import { GraphQLScalarType } from 'graphql';

export const GraphQLUlidType = new GraphQLScalarType({ name: 'Ulid' });
